@if(!browserSniffer.isPhone()) {
<div class="trace-header flex-container container-space-between column" tabindex="-1">
  <h4 class="">{{ "trace.view-route.title" | translate }}</h4>
  <div class="list-sub-header"
    [ngClass]="{'small': isActive() && ref_traceRouteData().metadata.name && ref_traceRouteData().metadata.name.length > 70}"
    [attr.title]="
    isActive() &&
          ref_traceRouteData().metadata.name
            ? ref_traceRouteData().metadata.name
            : ''
        ">
    @if (isActive() && ref_traceRouteData().metadata.name) {
    <span>
      {{ref_traceRouteData().metadata.name.length > 100 ? (ref_traceRouteData().metadata.name | slice: 0:100) + "..." :
      ref_traceRouteData().metadata.name}}
    </span>
    }
    @if (isActive() && !ref_traceRouteData().metadata.name) {
    <span class="untitled">
      {{("trace.view-route.routewithnoname"|translate)}}
    </span>
    }
  </div>
  <!-- : ("trace.view-route.routewithnoname" | translate) -->
  <!-- <div class="version" *ngIf="isActive() && ref_traceRouteData().metadata.time > -1" [innerHTML]="traceService.getTraceRouteData_metadatatime_string(false, true)"></div> -->
</div>
}

<div class="trace-utils flex-container surface-container-low">
  <!-- surface surface-variant-->
  <div class="btn-command-container">
    <!-- 
    <ng-template #traceShareTemplate let-ctx> together with (click)="ctx.openDialog()" doesn't work for the token injection in shareMapComponent
    -->
    <ng-template #traceShareTemplate>
      <button mat-icon-button class="primary-button btn-command"
        [ngClass]="{'mat-button-disabled': !isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap())}"
        [disabled]="!isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap())"
        [matTooltip]="'trace.share-tooltip' | translate" matTooltipPosition="above" (click)="shareMapComponent.openDialog()">
        <span class="mat-button-wrapper">
          <mat-icon>share</mat-icon>
          <div class="btn-command-label">{{"trace.share-btn"|translate}}</div>
        </span>
      </button>
    </ng-template>
    <tt-share-map #shareMapComponent [customTemplate]="traceShareTemplate"></tt-share-map>
  </div>

  <div class="btn-command-container">
    <button mat-icon-button class="primary-button btn-command"
      [ngClass]="{'mat-button-disabled':!isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap()) }"
      [disabled]="!isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap())"
      [matTooltip]="'trace.download-tooltip' | translate" matTooltipPosition="above" (click)="downloadTraceData()">
      <span class="mat-button-wrapper">
        <mat-icon>file_download</mat-icon>
        <div class="btn-command-label"
          [ngClass]="{'mat-button-disabled':!isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap()) }">
          {{"trace.download-btn"|translate}}</div>
      </span>
    </button>
  </div>

  <div class="btn-command-container">
    <button style="overflow: visible;" mat-icon-button class="primary-button btn-command"
      [ngClass]="{'mat-button-disabled': !isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap())}"
      [disabled]="!isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap())"
      [matTooltip]="'trace.print-tooltip' | translate" matTooltipPosition="above" (click)="pdfService.open()">
      <span class="mat-button-wrapper">
        <mat-icon>print</mat-icon>
        <div class="btn-command-label">{{"trace.print-btn"|translate}}</div>
      </span>
    </button>
  </div>

  @if(!hideTraceCreate) {
  <div class="btn-command-container">
    <!--span  *ngIf="browserSniffer.isPhone" style="position:absolute;top:3px;color:#2fa298;float:right;font-size:13px">&nbsp;NEW&nbsp;</span-->
    <button mat-icon-button class="primary-button btn-command" [ngClass]="{'mat-button-disabled': !isActive() }"
      [disabled]="!isActive()" [matTooltip]="'trace.edit-tooltip' | translate" matTooltipPosition="above"
      (click)="browserSniffer.isPhone()?editRoutePhone():editRoute()">
      <span class="mat-button-wrapper">
        <mat-icon>edit</mat-icon>
        <div class="btn-command-label">{{"trace.edit-btn"|translate}}</div>
      </span>
    </button>
  </div>
  }

  <div class="btn-command-container">
    <button mat-icon-button class="primary-button btn-command"
      [ngClass]="{'mat-button-disabled': !isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap() && !ref_isRouteWithGeneralInfo())}"
      [disabled]="!isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap() && !ref_isRouteWithGeneralInfo())"
      [matTooltip]="'trace.delete-tooltip' | translate" matTooltipPosition="above" (click)="resetData()">
      <span class="mat-button-wrapper">
        <mat-icon>delete</mat-icon>
        <div class="btn-command-label">{{"trace.delete-btn"|translate}}</div>
      </span>
    </button>
  </div>

</div>

<div class="trace-body column">
  <div class="trace-data">
    @if ((ref_hasRouteOnMap() || ref_hasWayPointsOnMap())) {

    <!-- route info-->
    @if (ref_hasRouteOnMap()) {
    <!-- <div class="mat-title-medium">
          {{ "trace.route_shortinfo" | translate }}
        </div> -->
    <div class="routeinfo">
      <div class="routeData mt-1 mb-1 ">
        <a [matTooltip]="'trace.total-distance' | translate" matTooltipPosition="above" [matTooltipShowDelay]="1000"
          class="route-length">
          <mat-icon fontSet="ngi" fontIcon="measure"></mat-icon>
          <span class="" [innerHTML]="ref_formattedRouteLength()"></span>
        </a>
        <div class="flex-container mt-1">
          <a [matTooltip]="'trace.total-height' | translate" matTooltipPosition="above" [matTooltipShowDelay]="1000"
            class="upward-distance flex-container align-baseline">
            <mat-icon fontSet="ngi" fontIcon="elevation-profile"></mat-icon>
            <span [innerHTML]="ref_formattedRouteUpwardDistance()"></span>
          </a>
          <a [matTooltip]="'trace.downward-height' | translate" matTooltipPosition="above" [matTooltipShowDelay]="1000"
            class="downward-distance flex-container align-baseline">
            <mat-icon fontSet="ngi" fontIcon="elevation-profile-downward"></mat-icon>
            <span [innerHTML]="ref_formattedRouteDownwardDistance()"></span>
          </a>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="routes">
        <!-- phone -->
        @if (browserSniffer.isPhone()) {
        <div class="routePoint route-utils">
          <div class="wayPoint title routeLimit startPoint showOnMap"
            [ngClass]="{'highlight': traceService.highlightedWayPoint() === 'startPoint'}" id="waypoint_startPoint"
            (click)="traceService.zoomToWayPoint('startPoint',$event)">
            <span>&nbsp;</span>
            {{ "trace.view-route.startpoint" | translate }}
          </div>
          <div class="wayPoint title routeLimit endPoint showOnMap"
            [ngClass]="{'highlight' : traceService.highlightedWayPoint() === 'endPoint'}" id="waypoint_endPoint"
            (click)="traceService.zoomToWayPoint('endPoint',$event)">
            <span>&nbsp;</span>
            {{ "trace.view-route.endpoint" | translate }}
          </div>
          <div class="title routeLimit zoomAll showOnMap" id="" (click)="traceService.zoomToRouteExtent()">
            <span>&nbsp;</span>
            {{ "trace.view-route.zoomAll" | translate }}
          </div>
          @if (isActive() && ref_hasRouteToCreateProfile()) {
          <div class="title routeLimit reverse showOnMap" id="" (click)="traceService.reverseRoute()">
            <span>&nbsp;</span>
            {{ "trace.reverse-route" | translate }}
          </div>
          }
          <!-- <div *ngIf="isActive() || ref_hasRouteToCreateProfile()" class="title routeLimit elevation" id=""
                (click)="traceService.toggleElevationProfile()">
                <span>&nbsp;</span>
                {{ "trace.route-profile" | translate }}
              </div> -->
        </div>
        }
        <!-- Desktop, tablet -->
        @if (!browserSniffer.isPhone()) {
        <div class="routePoint route-utils">
          <div class="title routeLimit startPoint" [ngClass]="{
            'highlight': traceService.highlightedWayPoint() === 'startPoint',
            'clkCENTER': traceService.highlightedWayPoint() === 'startPoint' && traceService.clickActionWayPoint() === 'clkCENTER', 
            'clkZOOMIN': traceService.highlightedWayPoint() === 'startPoint' && traceService.clickActionWayPoint() === 'clkZOOMIN', 
            'clkZOOMOUT': traceService.highlightedWayPoint() === 'startPoint' && traceService.clickActionWayPoint() === 'clkZOOMOUT'
            }" id="waypoint_startPoint" (click)="traceService.zoomToWayPoint('startPoint',$event)"
            (mouseenter)="traceService.addWayPointHighlight('startPoint', false)"
            (mouseleave)="traceService.removeWayPointHighlight()">
            <span>&nbsp;</span>
            {{ "trace.view-route.startpoint" | translate }}
          </div>
          <div class="title routeLimit endPoint highlight clkZOOMIN" [ngClass]="{
              'highlight' : traceService.highlightedWayPoint() === 'endPoint',
              'clkCENTER': traceService.highlightedWayPoint() === 'endPoint' && traceService.clickActionWayPoint() === 'clkCENTER', 
              'clkZOOMIN': traceService.highlightedWayPoint() === 'endPoint' && traceService.clickActionWayPoint() === 'clkZOOMIN', 
              'clkZOOMOUT': traceService.highlightedWayPoint() === 'endPoint' && traceService.clickActionWayPoint() === 'clkZOOMOUT'           
            }" id="waypoint_endPoint" (click)="traceService.zoomToWayPoint('endPoint',$event)"
            (mouseenter)="traceService.addWayPointHighlight('endPoint', false)"
            (mouseleave)="traceService.removeWayPointHighlight()">
            <span>&nbsp;</span>
            {{ "trace.view-route.endpoint" | translate }}
          </div>
          <div class="title routeLimit zoomAll" id="" (click)="traceService.zoomToRouteExtent()">
            <span>&nbsp;</span>
            {{ "trace.view-route.zoomAll" | translate }}
          </div>
          @if (isActive() || ref_hasRouteToCreateProfile()) {
          <div class="title routeLimit elevation" id="" (click)="traceService.toggleElevationProfile()">
            <span>&nbsp;</span>
            {{ "trace.route-profile" | translate }}
          </div>
          }
          @if (isActive() && ref_hasRouteToCreateProfile()) {
          <div class="title routeLimit reverse" id="" (click)="traceService.reverseRoute()">
            <span>&nbsp;</span>
            {{ "trace.reverse-route" | translate }}
          </div>
          }
        </div>
        }
      </div>
    </div>
    }
    <!-- description -->
    @if (ref_traceRouteData().metadata.desc) {
    <mat-divider></mat-divider>
    <div class="mt-1 mb-1 routeDescription">
      <div class="mat-title-medium">
        {{ "trace.description" | translate }}
      </div>
      <div [innerHTML]="ref_traceRouteData().metadata.desc"></div>
      <div class="mt-2">
        <mat-divider></mat-divider>
      </div>
    </div>
    }

    <!--waypoints-->
    @if (isActive() && ref_hasWayPointsOnMap()) {

    <div class="mat-title-medium mt-1">{{ "trace.pois" | translate }}</div>
    <div class="wayPoints">
      @for (
      wayPoint of ref_traceRouteData().wayPoints; track
      wayPoint.drawId; let i = $index) {
      <div [attr.id]="'wayPoint_' + i" tabindex="-1" class="wayPoint"
        [ngClass]="{'highlight': traceService.highlightedWayPoint() === i}"
        (click)="traceService.zoomToWayPoint(i,$event)" (mouseenter)="traceService.addWayPointHighlight(i, false)"
        (mouseleave)="traceService.removeWayPointHighlight()">
        @if (!browserSniffer.isPhone()) {
        <div class="title"
          [innerHTML]="'<div class=\'index-container\'><span>' + (this.ref_traceSettingsSequenceNumberAlpha ? convertWayPointIndexToLetter(i + 1) : (i + 1)) + ' </span></div>' + (wayPoint.name ? wayPoint.name : ('<div class=\'untitled\'>'  +('trace.field.noname' | translate)+ '</div>'))"
          [ngClass]="{ 
              'clkCENTER': traceService.highlightedWayPoint() === i && traceService.clickActionWayPoint() === 'clkCENTER', 
              'clkZOOMIN': traceService.highlightedWayPoint() === i && traceService.clickActionWayPoint() === 'clkZOOMIN', 
              'clkZOOMOUT': traceService.highlightedWayPoint() === i && traceService.clickActionWayPoint() === 'clkZOOMOUT' }">
        </div>
        }
        @if (browserSniffer.isPhone()) {
        <div class="title showOnMap"
          [innerHTML]="'<div class=\'index-container\'><span>' + (this.ref_traceSettingsSequenceNumberAlpha ? convertWayPointIndexToLetter(i + 1) : (i + 1)) + ' </span></div>' + (wayPoint.name ? wayPoint.name : ('<div class=\'untitled\'>'  +('trace.field.noname' | translate)+ '</div>'))">
        </div>
        }
        <div class="description" [innerHTML]="wayPoint.desc? wayPoint.desc : ''"></div>
        <div class="coord" [innerHtml]="wayPoint.formattedXY"></div>
      </div>
      }
    </div>
    } @else {
    <ng-template [ngTemplateOutlet]="showNgTemplateNoPoints"></ng-template>
    }
    } @else {
    <div class="noPoints mt-1">{{ "trace.no-route-loaded" | translate }}
      <div class="mt-1">
        <button color="primary" mat-stroked-button
          (click)="traceService.openTraceTab_str('IMPORT_ROUTE')">{{'trace.route_upload' | translate}}</button>
      </div>
      @if(!hideTraceCreate){
      <div class="mt-1">
        <button color="primary" mat-stroked-button
          (click)="traceService.openTraceTab_str('CREATE_ROUTE')">{{'trace.route_draw' | translate}}</button>
      </div>
      }
    </div>
    }

  </div>
</div>